export const tirePositions = ["LF", "RF", "LB", "RB"];
